import config from '@conf'
import { contractsService } from '@api/contracts.service'
import { RecordFactory } from '@js/records/factory'
import { Paginator } from '@js/helpers/paginator'

const state = {
  signedContracts: new Paginator({
    txPerPage: config.SIGNATURE_REQUESTS_PER_PAGE,
    recordWrp: RecordFactory.createContractRecord.bind(RecordFactory)
  }),
  archivedContracts: new Paginator({
    txPerPage: config.SIGNATURE_REQUESTS_PER_PAGE,
    recordWrp: RecordFactory.createContractRecord.bind(RecordFactory)
  })
}

const mutations = {
}

const actions = {
  async GET_SIGNED_CONTRACTS ({ state }, filters) {
    state.signedContracts.attachInitLoader(() => contractsService.loadContracts(filters))
    return state.signedContracts.init()
  },

  async NEXT_SIGNED_CONTRACTS ({ state }) {
    return state.signedContracts.next()
  },

  async GET_ARCHIVED_CONTRACTS ({ state }, filters) {
    state.archivedContracts.attachInitLoader(() => contractsService.loadContracts(filters))
    return state.archivedContracts.init()
  },
  async NEXT_ARCHIVED_CONTRACTS ({ state }) {
    return state.archivedContracts.next()
  }
}

const getters = {
  signedContracts: state => state.signedContracts,
  archivedContracts: state => state.archivedContracts
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/contracts.module.js